import { Card } from '@mui/material';
import { PolygonGeometryMap } from 'components/LocationForm/PolygonGeometryMap';
import { FunctionComponent, useContext } from 'react';
import { LocationFormContext } from '../../context';
import { DETAILS } from '../const';
import { useMapStyles } from './styles';
import { Polygon } from 'types';

export const LocationPolygonMap: FunctionComponent<{
  polygonColor: string;
  polygonOpacity: number;
}> = ({ polygonColor, polygonOpacity }) => {
  const { values, setValues, setDirty } = useContext(LocationFormContext);
  const classes = useMapStyles();

  const handleAreaSelection = (geometry: Polygon) => {
    setDirty(DETAILS, true);
    setValues((prev) => {
      return {
        ...prev,
        geometry,
      };
    });
  };

  return (
    <Card className={classes.fullHeight}>
      <PolygonGeometryMap
        geometry={values.geometry as Polygon | undefined}
        onChange={handleAreaSelection}
        polygonColor={polygonColor}
        polygonOpacity={polygonOpacity}
      />
    </Card>
  );
};
